import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  container: {},
  contentItem: {
    position: 'relative',
    transition: 'all 0.01s linear',
    boxSizing: 'border-box',
  },
  contentItemFocused: {
    border: `1px solid ${theme.colors.mainGreen6}`,
    borderRadius: '0 2px 2px 2px',
    backgroundColor: theme.colors.gray1,
  },
  contentItemTitle: {
    marginBottom: 20,
  },
  contentItemOthers: {
    marginBottom: 16,
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: -24,
    left: -1,
    height: 24,
    padding: '0 8px',
    color: theme.colors.gray1,
    backgroundColor: theme.colors.mainGreen6,
    borderRadius: '2px 2px 0 0',
  },
  labelText: {
    color: theme.colors.gray1,
    paddingLeft: 4,
  },
  addonAfter: {
    position: 'absolute',
    right: 0,
    bottom: -44,
    cursor: 'pointer',
    backgroundColor: theme.colors.gray1,
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.16)',
    zIndex: 1000,
  },
  removeIcon: {
    display: 'inline-flex',
    fontSize: 16,
    padding: '12px 16px',
    color: theme.colors.red11,
    borderRadius: 2,

    '&>span': {
      cursor: 'pointer',
    },
  },
  text: {
    padding: 0,
    margin: 0,
    outline: 'none',
    border: 'none',
    boxShadow: 'none',
  },
  titleText: {
    ...theme.typography.h2,
    color: theme.colors.titleColor,

    '&::placeholder': {
      fontSize: 24,
      lineHeight: '32px',
    },
  },
  subTitleText: {
    ...theme.typography.body3,
    color: theme.colors.bodyColor,

    '&::placeholder': {
      fontSize: 14,
      lineHeight: '22px',
    },
  },
  textAreaText: {
    ...theme.typography.body2,
    color: theme.colors.bodyColor,

    '&::placeholder': {
      fontSize: 14,
      lineHeight: '22px',
    },
  },
  inputText: {
    border: 'none',
    outline: 'none',
    resize: 'none',

    '&:focus': {
      border: 'none',
      boxShadow: 'none',
    },
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 294,
    textAlign: 'center',
    overflow: 'hidden',
    backgroundColor: theme.colors.gray2,

    '& > img': {
      width: '100%',
      height: 'auto',
    },

    '& .ant-upload': {
      border: 'none',
    },
  },
  uploadTitle: {
    fontSize: 16,
    lineHeight: '24px',
    color: theme.colors.titleColor,
    marginTop: '20px !important',
  },
  uploadSummary: {
    ...theme.typography.body2,
    color: theme.colors.captionColor,
    marginTop: '4px !important',
  },
  videoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 294,
    textAlign: 'center',
    overflow: 'hidden',
    border: '1px solid rgba(0, 0, 0, 0.06)',
    backgroundColor: theme.colors.gray2,
    borderRadius: '0 2px 2px 2px',

    '& > div': {
      minHeight: 294,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  videoContainerError: {
    backgroundColor: '#FFF1F0',
  },
  videoName: {
    ...theme.typography.body1,
    color: theme.colors.titleColor,
    marginBottom: 40,
    marginTop: 0,
  },
  videoProgress: {
    display: 'flex',
    alignItems: 'center',
  },
  videoProgressNum: {
    ...theme.typography.body5,
    color: theme.colors.titleColor,
    paddingLeft: 8,
  },
  videoProgressBar: {
    position: 'relative',
    height: 6,
    backgroundColor: theme.colors.gray4,
    borderRadius: 100,
  },
  videoProgressInner: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    backgroundColor: theme.colors.blue6,
    borderRadius: 100,
    transition: 'all 1s linear',
  },
  videoErrorWrapper: {
    width: '100%',
  },
  videoErrorNotice: {
    ...theme.typography.body1,
    color: theme.colors.titleColor,
    marginBottom: 8,
  },
  videoSuccessWrapper: {
    width: '100%',
    flexDirection: 'column',
  },
  videoSuccessContent: {
    flex: 1,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colors.mainGreen1,
  },
  videoSuccessName: {
    ...theme.typography.body1,
    color: theme.colors.titleColor,
    margin: 0,
  },
  videoLoadingWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  videoTitleWrapper: {
    width: '100%',
    padding: '16px 80px',

    '& .ant-form-item': {
      display: 'flex',
      marginBottom: 0,
      lineHeight: '32px',
    },

    '& .ant-form-item-label': {
      width: 102,
      lineHeight: '32px',
      marginRight: 8,
    },

    '& .ant-form-item-control-wrapper': {
      flex: 1,
    },
  },
  videoWrapper: {
    width: '100%',

    '& > span': {
      display: 'inline-block',
      width: '100%',
    },

    '& .ant-upload': {
      minHeight: 294,
    },
  },
  titleLabel: {
    ...theme.typography.body2,
    color: theme.colors.titleColor,
    paddingRight: 4,
  },
  optionalLabel: {
    ...theme.typography.body2,
    color: theme.colors.captionColor,
  },
}));

export default useStyles;
